import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useReport } from "../../context/report";

export default function Residuos() {
    const { data } = useReport();
    
    return (
        <div>
            <DataTable
                responsiveLayout="scroll"
                value={data}
            >
                <Column header="Resíduo" field="residuo" />
                <Column header="Quantidade (kg)" field="qtde" />
                <Column header="Setor" field="setor" />
            </DataTable>
        </div>
    )
}